import React from 'react';
import ReactDOM from 'react-dom/client';

// Self-hosted fonts via @fontsource (GDPR-safe — Google Fonts hot-loading was
// ruled a GDPR violation by LG München I, Az. 3 O 17493/20). Vercel serves
// these from origin so EU visitors don't ping fonts.googleapis.com.
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/space-grotesk/500.css';
import '@fontsource/space-grotesk/600.css';
import '@fontsource/space-grotesk/700.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// PWA service worker (DESIGN_ROADMAP §7). Hand-rolled in /sw.js so we
// can keep the dependency footprint flat. Only registers in production.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

reportWebVitals();
